import QuestionsAreaContainer from './QuestionsAreaContainer';

export default QuestionsAreaContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/QuestionsArea/index.js